import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResidentialHistoryComponent } from './residential-history/residential-history.component';
import { SharedModule } from '@shared';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_DATE_FORMATS, MY_DATE_ADAPTER } from './date-format';

const COMPONENTS = [
  ResidentialHistoryComponent
]

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    SharedModule,
    CommonModule,
    MatDatepickerModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    MY_DATE_FORMATS,
    MY_DATE_ADAPTER,
  ],
  exports: [ResidentialHistoryComponent]
})
export class ResidentialHistoryModule { }
